function Roadmap() {
  return (
    <section className="colored" id="ROADMAP">
      <span className="section_title">The Roadmap</span>

      <br />
      <br />
      <br />

      <img src="img/roadmap.svg" alt="" className="roadmap" />
    </section>
  );
}

export default Roadmap;
